export default __webpack_public_path__ + "assets/images/7bc36d627959e65acec39d4f3b86d82a.svg";